// Angular
import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

// Data/Classes/Others
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ManagerDeleteComponent } from '../manager-delete/manager-delete.component';
//import { accountTypeEdit,accountTypesEditAdmin } from '../../../accounts';
import { ManagerIFace } from 'src/app/shared/classes';
import { planModel, adminType , licenseType, accountType, permissionLevel, hostingList, tierist } from '../../../data-tables'


// Services
import { AdminService } from 'src/app/services/admin/admin.service';
import { MessagesService } from 'src/app/services/message/messages.service';
import { EventsService } from 'src/app/services/events/events.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { allCountries } from '../../../countries';



import * as moment from 'moment';


@Component({
  selector: 'app-manager-edit',
  templateUrl: './manager-edit.component.html',
  styleUrls: ['./manager-edit.component.less']
})
export class ManagerEditComponent implements OnInit {
  @Input() manager: ManagerIFace;
  public managerEditForm;
  public listaccType;
  public listadminType;
  public listplanModel;
  public listlicenseType;
  public accountTemp :any;
  public permissionLevel = permissionLevel;
  public hostingList = hostingList;
  public listOfAllCountries = allCountries;
  public tierList = tierist;


  constructor(private fb: FormBuilder, private admin: AdminService, private msg: MessagesService, private ngbModal: NgbModal,
    private ngbActModal: NgbActiveModal, private event: EventsService, private load: NgxSpinnerService) {
  }

  ngOnInit() {
    this.initForm();
  }

  // inits edit user form
  private initForm() {
    this.listadminType = adminType;
    this.listplanModel = planModel;
    this.listlicenseType = licenseType;
    this.listaccType = accountType;

    this.managerEditForm = this.fb.group({
      admin_id: [this.manager.data['admin_id']],
      first_name: [this.manager.data['first_name']],
      last_name: [this.manager.data['last_name']],
      email: [this.manager.data['email']],
      mobile: [this.manager.data['mobile']],
      organisation:[this.manager.data['organisation']],
      country:[this.manager.data['country']],
      admin_type:[this.convertCodeType("adminType",this.manager.data['admin_type'])],
      plan_model:[this.convertCodeType("planModel",this.manager.data['plan_model'])],
      sub_account_type:[this.manager.data['sub_account_type']],
      sub_account_limit:[this.manager.data['sub_account_limit']],
      license_type:[this.manager.data['license_type']],
      status:[this.manager.data['status']],
      start_date:[moment(this.manager.data['start_date']).format('YYYY-MM-DDThh:mm')],
      expire_date:[moment(this.manager.data['expire_date']).format('YYYY-MM-DDThh:mm')],
      permission_level : [this.manager.data['permission_level']],
      hosting : [this.manager.data['hosting']],
      //tier : [this.manager.data['tier']],
    });

  }

  // updates user
  public updateUser() {
    //this.load.show();
    let formData = {
      first_name: this.managerEditForm.value.first_name,
      last_name:this.managerEditForm.value.last_name ,
      organisation:this.managerEditForm.value.organisation,
      country: this.countryCode(this.managerEditForm.value.country),
      admin_id:this.managerEditForm.value.admin_id,
      email: this.managerEditForm.value.email,
      mobile: this.managerEditForm.value.mobile,
      password: this.managerEditForm.value.password,
      admin_type:this.reconvertCodeType("adminType",this.managerEditForm.value.admin_type),
      plan_model:this.reconvertCodeType("planModel",this.managerEditForm.value.plan_model),
      sub_account_type:this.managerEditForm.value.sub_account_type,
      sub_account_limit:this.managerEditForm.value.sub_account_limit,
      permission_level:this.managerEditForm.value.permission_level,
      subscription_date:[moment(this.managerEditForm.value.start_date).toISOString(),moment(this.managerEditForm.value.expire_date).toISOString()],
      license_type:this.managerEditForm.value.license_type,
      installation_date:this.managerEditForm.value.installation_date,
      remarks:this.managerEditForm.value.remarks,
      hosting: this.managerEditForm.value.hosting,
      //tier:this.managerEditForm.value.tier,
      status:this.managerEditForm.value.status
     }
     this.admin.updateTheManager(formData)
     .then(res => this.success(res))
     .catch(err => this.error(err));
 }
  


  // triggers delete user modal
  public triggerDeleteUserModal() {
    // open delete modal
    const modal = this.ngbModal.open(ManagerDeleteComponent);
    modal.componentInstance.managerDetails = this.manager;

    modal.result
      .then((msg) => {
        if (msg.success) {
          const admin_id = msg.user;

          this.ngbActModal.close({ user: admin_id, task: 'close modal', success: true });
        }
      })
      .catch((msg) => {
        console.log(msg);
      });
  }

  // handle success
  private success(res) {
    this.load.hide();
    this.event.getTableTriggers();
    this.msg.success(res);
    this.ngbActModal.close();
  }

  // handle error
  private error(err) {
    this.load.hide();
    this.msg.error(err);
  }

  public checkAccount(acc){
      this.accountTemp = acc;
  }

  private convertCodeType(type,value){
    let output = "";
    switch(type){
      case "adminType":
        if(value == "ECO"){
          output = "Ecosystem";
          return output;
        }
        if(value == "P"){
           output = "Provider";
           return output;
        }
     break;
     case "planModel":
        if(value == "ECO-B"){
           output = "Ecosystem Beginner";
           return output;
        }
        if(value == "ECO-D"){
           output = "Ecosystem Developer"
           return output;
        }
        if(value == "ENTP-B"){
           output = "Enterpise Premise Beginner";
           return output;
        }
        if(value == "ENTP-D"){
           output = "Enterprise Premise Developer";
           return output;
        }
        if(value == "ENTC-B"){
         output = "Enterpise Cloud Beginner";
         return output;
        }
        if(value == "ENTC-D"){
         output = "Enterprise Cloud Developer";
         return output;
        }
     break;
    }
  }

  private reconvertCodeType(type,value){
    let output = "";
    switch(type){
        case "adminType":
           if(value == "Ecosystem"){
             output = "ECO";
             return output;
           }
           if(value == "Provider"){
              output = "P";
              return output;
           }
        break;
        case "planModel":
          if(value == "Ecosystem Beginner"){
            output = "ECO-B";
            return output;
         }
         if(value == "Ecosystem Developer"){
            output = "ECO-D"
            return output;
         }
         if(value == "Enterpise Premise Beginner"){
            output = "ENTP-B";
            return output;
         }
         if(value == "Enterprise Premise Developer"){
            output = "ENTP-D";
            return output;
         }
         if(value == "Enterpise Cloud Beginner"){
           output = "ENTC-B";
           return output;
         }
         if(value == "Enterprise Cloud Developer"){
           output = "ENTC-D";
           return output;
         }
        break;
    }
   }

    private countryCode(name){
        for (let i = 0; i < this.listOfAllCountries.length; i++){
            if(this.listOfAllCountries[i].name == name){
               return this.listOfAllCountries[i].type;
            }
        }
    }
}
